import { enqueueSnackbar, VariantType } from 'notistack';

export const showSnackbar = (message: string, variant: VariantType) => {
  enqueueSnackbar(message, { variant, autoHideDuration: 3000 });
};
